<template>
  <div class="exhibition_wrap container flex" v-if="list.length > 0">
    <div class="exhibition_left">
      <div class="title">
        <span>{{ langSet === "cn" ? list[0].cate : list[0].cate_en }}</span>
      </div>
      <div class="ex_list flex flex_wrap flex_content_sb">
        <div
          class="ex_item flex flex_items_center"
          :class="langSet == 'cn' ? '' : 'ex_en'"
          v-for="(item, index) in list[0].list"
          :key="index"
          @click="toLink(item)"
        >
          <img class="icon" :src="item.icon" alt="" />
          <div class="title">
            {{ langSet == "cn" ? item.title : item.title_en }}
          </div>
        </div>
      </div>
    </div>
    <div class="exhibition_right">
      <div class="title">
        <span>{{ langSet === "cn" ? list[1].cate : list[1].cate_en }}</span>
      </div>
      <div class="ex_list">
        <div
          class="ex_item flex flex_items_center flex_content_center"
          :class="langSet == 'cn' ? '' : 'ex_en'"
          v-for="(item, index) in list[1].list"
          :key="index"
          @click="toLink(item)"
        >
          <img class="icon" :src="item.icon" alt="" />
          <div class="title">
            {{ langSet == "cn" ? item.title : item.title_en }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WebNavigation } from "@/api/api";
export default {
  data() {
    return {
      langSet: "",
      list: [],
    };
  },
  mounted() {
    this.langSet = this.$language;
    //25.6.9 获取首页中部导航 dxm
    this.getWebNavigationList();
  },
  methods: {
    async getWebNavigationList() {
      const res = await WebNavigation();
      this.list = res.data.lists;
    },
    //跳转页面
    toLink(item) {
      console.log(item, "====item");
      if (item.url || item.url_en) {
        if (item.type == "内部跳转") {
          this.$router.push({
            path: this.langSet == "cn" ? item.url : item.url_en,
          });
        } else {
          let path = this.langSet == "cn" ? item.url : item.url_en;
          window.open(path, "_blank");
        }
      } else {
        window.open(item, "_blank");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.exhibition_wrap {
  // margin-top: -346px;
  justify-content: space-between;
  > div {
    // padding: 40px;
    height: 423px;
    box-sizing: border-box;
    .title {
      color: #000;
      font-size: 24px;
      font-weight: 600;
      line-height: 33px;
      span {
        margin-right: 20px;
      }
    }
  }
  .exhibition_left {
    // width: 770px;
    flex: 1;
    margin-right: 50px;
    // background: #011150;
    .ex_list {
      padding-top: 10px;
      .ex_item {
        width: 380px;
        height: 148px;
        color: #fff;
        font-size: 20px;
        margin-top: 20px;
        font-weight: 500;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        border-radius: 40px;
        background: #0f3481;
        overflow: hidden;
        display: flex;
        justify-content: center;
        .icon {
          width: 48px;
          margin-right: 15px;
        }
        .title {
          color: #fff;
          position: relative;
          z-index: 9;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 0.3s;
          // 25.11.26 更换背景图  dxm
          background: url("../../../assets/imgs/ex_bg.jpg") no-repeat;
          background-size: 100%;
        }
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 0.3s;
          background: rgba(0, 0, 0, 0.6);
        }
        &:hover {
          padding-left: 0;
          justify-content: center;
          .icon {
            display: none;
          }
        }
        &:hover::before {
          opacity: 1;
        }
        &:hover::after {
          opacity: 1;
        }
      }
    }
  }
  .exhibition_right {
    width: 460px;
    // background: #e11135;
    .ex_list {
      padding-top: 10px;
      .ex_item {
        width: 100%;
        height: 148px;
        color: #fff;
        font-size: 20px;
        margin-top: 20px;
        font-weight: 500;
        border-radius: 40px;
        cursor: pointer;
        position: relative;
        background: #cf121b;
        overflow: hidden;
        .icon {
          width: 48px;
          margin-right: 15px;
        }
        .title {
          color: #fff;
          position: relative;
          z-index: 9;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 0.3s;
          // 25.11.26 更换背景图 dxm
          background: url("../../../assets/imgs/ex_bg1.jpg") no-repeat;
          background-size: 100% 100%;
        }
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 0.3s;
          background: rgba(0, 0, 0, 0.6);
        }
        &:hover {
          padding-left: 0;
          justify-content: center;
          .icon {
            display: none;
          }
        }
        &:hover::before {
          opacity: 1;
        }
        &:hover::after {
          opacity: 1;
        }
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .exhibition_wrap {
    > div {
      height: auto;
      .title {
        font-size: 22px;
      }
    }
    .exhibition_left {
      margin-right: 30px;
      .ex_list .ex_item {
        width: 47%;
        height: 100px;
        padding-left: 0;
        justify-content: center;
        .title {
          font-size: 18px;
        }
        .icon {
          width: 35px;
        }
      }
    }
    .exhibition_right {
      width: 360px;
      .ex_list .ex_item {
        height: 100px;
        .title {
          font-size: 18px;
        }
        .icon {
          width: 35px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .exhibition_wrap {
    flex-wrap: wrap;
    margin-top: 0;
    > div {
      padding: 0.58rem 0;
      .title {
        font-size: 0.35rem;
      }
    }
    .exhibition_left {
      margin-right: 0;
      .ex_list {
        padding-top: 0.19rem;
        .ex_item {
          width: 48%;
          height: 1.15rem;
          padding-left: 0.2rem;
          justify-content: center;
          margin-top: 0.19rem;
          .title {
            font-size: 0.27rem;
            line-height: inherit;
          }
          .icon {
            width: 0.54rem;
            margin-right: 0.23rem;
          }
        }
      }
    }
    .exhibition_right {
      width: 100%;
      .ex_list {
        display: flex;
        justify-content: space-between;
        padding-top: 0.19rem;
        .ex_item {
          width: 48%;
          height: 1.15rem;
          margin-top: 0.19rem;
          .title {
            font-size: 0.27rem;
          }
          .icon {
            width: 0.53rem;
          }
        }
      }
    }
  }
}
</style>